/* Sticky add-to-cart bar - behaviour. Owner: snippets/product-sticky-add-to-cart.liquid */

(function () {
  function initStickyBar() {
    var bar = document.getElementById('kaayu-sticky-bar');
    var atcRow = document.querySelector('.product-buy-buttons');
    if (!bar || !atcRow) return;

    // Mount the bar directly on <body> as the LAST child, once, up front -
    // no delayed re-parenting, no race condition where it briefly lives
    // inside a transformed / isolated ancestor (e.g. the scroll-animate
    // wrapper or the vertical thumbnail carousel's stacking context).
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    var img = document.querySelector('.product-media-item img, .product-gallery__slide img');
    var name = document.querySelector('.product-name-wrapper h1, h1.h2');
    var price = document.querySelector('.regular-price .money');

    var imgEl = document.getElementById('kaayu-sticky-img');
    var nameEl = document.getElementById('kaayu-sticky-name');
    var priceEl = document.getElementById('kaayu-sticky-price');

    if (img && imgEl) {
      imgEl.src = img.currentSrc || img.src;
      imgEl.alt = img.alt || '';
    }
    if (name && nameEl) nameEl.textContent = name.textContent.trim();
    if (price && priceEl) priceEl.textContent = price.textContent.trim();

    function setVisible(show) {
      bar.classList.toggle('visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.documentElement.classList.toggle('kaayu-atc-visible', show);

      if (show) {
        var h = bar.offsetHeight || 80;
        document.documentElement.style.setProperty('--kaayu-sticky-bar-height', h + 'px');
      }
    }

    // Bar shows once the real add-to-cart row has scrolled OUT of view,
    // hides again once it's back in view. Single IntersectionObserver,
    // single source of truth - no MutationObserver guesswork elsewhere.
    var lastState = null;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var stateKey = entry.isIntersecting ? 'inside' : 'outside';
          if (lastState !== stateKey) {
            lastState = stateKey;
            setVisible(!entry.isIntersecting);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    );
    observer.observe(atcRow);

    // Hide the bar whenever any modal / cart drawer opens (body.no-scroll
    // is the theme's own signal for that - no fuzzy selector-hunting).
    var bodyObserver = new MutationObserver(function () {
      if (document.body.classList.contains('no-scroll')) {
        bar.classList.add('kaayu-force-hidden');
      } else {
        bar.classList.remove('kaayu-force-hidden');
      }
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.getElementById('kaayu-sticky-btn').addEventListener('click', function () {
      var realBtn = document.querySelector('.button-add-to-cart');
      if (realBtn) realBtn.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();
